import React from 'react';

// Matches http(s) URLs up to the next whitespace character.
const URL_REGEX = /(https?:\/\/[^\s]+)/g;

type Props = {
  text?: string | null;
};

/**
 * Renders plain message text while turning any http(s) URL into a clickable link.
 * Uses no dangerouslySetInnerHTML, so it is safe against HTML/script injection.
 */
export const LinkifiedText: React.FC<Props> = ({ text }) => {
  if (!text) return null;

  const parts = text.split(URL_REGEX);

  return (
    <>
      {parts.map((part, index) => {
        if (/^https?:\/\//.test(part)) {
          return (
            <a
              key={index}
              href={part}
              target='_blank'
              rel='noopener noreferrer'
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
          );
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </>
  );
};
